import React, { useEffect, useState } from 'react'
import './profile.css'
import Fotter from '../../Home/Home_modules/Footerr/footer'
import firebaseConfig from '../../fire';
import { toast } from "react-toastify";
import { getAuth } from "firebase/auth";
import firebase from '@firebase/app-compat';




function Edit_Profile(){
    const [ userData, setUserData ] = useState(null);
    const [ userDoc, setUserDoc ] = useState('');
    const [ avatar, setAvatar ] = useState(null);
    const [editCover, setEditCover] = useState(false);
    const [editAvatar, setEditAvatar] = useState(false);

    function updateprofile() {
       
        var updatedname = document.getElementById('name').value;
        var updatedemail = document.getElementById('email').value;
        var updatednumber = document.getElementById('number').value;
        //alert(updatedname + updatedemail + updatednumber )

        localStorage.setItem('User Name', updatedname)
        localStorage.setItem('User E-mail', updatedemail)
        localStorage.setItem('User Contact Number', updatednumber)

        toast.success("Horray..! User Updated Successfully!")    

      }

      function updatepassword() {

        var password = document.getElementById('newpassword').value;
        var cpassword = document.getElementById('confirmpassword').value;

        if( password == cpassword){
            //alert("Matched");
            var user = firebase.auth().currentUser;
            var newPassword = document.getElementById('newpassword').value;

            user.updatePassword(newPassword).then(function() {

                alert("Please Login again to continue");

                toast.success("Wow..! Password Updated")    

              }).catch(function(error) {
                
                toast.warning("Something Went Wrong")   

              });
        }
       else{
        toast.warning("OMG..! Confirm Password Not Matched !")  
           //alert("Not Matched");
       }
       

      }


 firebaseConfig.auth().onAuthStateChanged(function(user) {
if(user) {
 
} else {
  toast.warning("Please Login to Continue")  
  window.location.href = "../login";
}    
})

const [allBiddata, setAllBiddata] = useState([]);
const [allPurchases, setAllPurchases] = useState([]);





useEffect(() => {
    const userData = firebase.firestore().collection('users').where('uid', '==', getAuth()
    .currentUser.uid).get({ source: 'server' }).then(res => {
        if (res.docs.length  == 1) {
        console.log('user details', res.docs[0].data())
        setUserData(res.docs[0].data())
        setUserDoc(res.docs[0].id)
       setUserData({userdetails: res.docs[0].data()});
        console.log("Name:",res.docs[0].data().name);

        localStorage.setItem('User Name', res.docs[0].data().name)
        localStorage.setItem('User E-mail', res.docs[0].data().email)
        localStorage.setItem('User Contact Number', res.docs[0].data().phone)
       
        //alert(res.docs[0].data().name)
     //   console.log(this.state.userdata.value);

               
    } else {
        
    }
    }).catch(err => {
        console.log('Something went wrong in user details API', err)
    })

    

}, []);

  
const username = localStorage.getItem('User Name')
const useremail = localStorage.getItem('User E-mail')
const contactnumber = localStorage.getItem('User Contact Number')

    return(
        
        <>
        <div className='main'>
            <h1 className="editprofile-head">Edit Profile</h1>
            <div className="editprofile-container">
                <div className="editprofile-col">
                    <h3>PERSONAL INFO</h3>
                    <form onSubmit={updateprofile}>
                        <label>Name</label>
                        <input type="text" id="name" name="oldpassword" style={{color: 'white'}} placeholder={username} />
                        <label>Phone</label>
                        <input type="text" id="email" name="oldpassword" style={{color: 'white'}} placeholder={contactnumber} />
                    
                        <label>Email</label>
                        <input type="text" id="number" name="oldpassword" style={{color: 'white'}} placeholder={useremail}/>
                   
                        <button>Save Changes</button>
                    </form>
                    </div>
                <div className="editprofile-col">
                    <h3>SECURITY</h3>
                    <form  onSubmit={updatepassword}>
                       
                        <label>New Password</label>
                        <input type="password" style={{color: 'white'}}  id="newpassword" placeholder="New Password" />
                        <label>Confirm Password</label>
                        <input type="password" style={{color: 'white'}}  id="confirmpassword" placeholder="Confirm Password" />

                        
                        <button>Update Password</button>
                    </form>
                    </div>
                </div>
        </div>
        <Fotter />
        </>
    )
}

export default Edit_Profile;